import React, { useState } from "react";

import "./AdminLayout.css"; 
import AdminNavbar from "./AdminNavbar";
import AdminSidebar from "./AdminSidebar";
import { ToastContainer } from "react-toastify";

const AdminLayout = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const handleSidebarToggle = () => {
    setIsSidebarCollapsed((prevState) => !prevState);
  };

  const handleSidebarExpand = () => {
    setIsSidebarCollapsed(false);
  };

  return (
    <div className="admin-layout">
      <ToastContainer />

      <AdminNavbar onToggleSidebar={handleSidebarToggle} />
      <div className="admin-content">
        <AdminSidebar
          isCollapsed={isSidebarCollapsed}
          onExpandSidebar={handleSidebarExpand}
        />
        <div className="admin-main">{children}</div>
      </div>
    </div>
  );
};

export default AdminLayout;
